import LocationFinder from "../modules/location-finder.js";

if (document.getElementById("location-page")) {
  window.locationFinder = new LocationFinder();
}
